import React from "react";
import { observer } from "mobx-react";
import emissionViewStore from "../../../Store/marco/emissionViewStore";
import styles from "../styles/EmissionActivityModal.module.css";
import loadingSvg from "../../../Assets/images/tube-spinner.svg";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { EFDec } from "../EFDec";
import { getEFSchemaByStandard } from "../utils/getEFSchemaByStandard";
import { SchemaSwitcher } from "../utils/SchemaSwitcher";
import { EFFormComponent } from "../form/EFFormComponent";
import { Selector } from "../Select";
import { flattenEAFormData } from "../form/utils/toRequestBody";
const specialCats = [];

export const EFModal = observer(() => {
  const store = emissionViewStore;
  const { t } = useTranslation("ActivityMain");

  const EFSchema = getEFSchemaByStandard(store.standardId)[store.selectedTab];

  const isLoading = store.emissionActivityModalLoading >= 1;

  const flatEAFormData = flattenEAFormData(store.EAFormData);

  ////////關閉選單
  const handleClose = () => {
    store._handleCloseEmissionFactorEditModal();
    store._handleReSetEAFormData();
    store._handleReSetEFFormData();
    store._handleReSetEFFormData("EFLandFormData");
    store._handleReSetEFFormData("EFSeaFormData");
    store._handleReSetEFFormData("EFAirFormData");
  };

  const handleEdit = async () => {
    await store.editEF();
  };

  return (
    <div className={styles.bgc}>
      <div
        className={`${styles.container} ${isLoading ? styles.isLoading : ""}`}
      >
        {/** Loading 頁面 */}
        {isLoading && (
          <div className={styles.loading}>
            <img className={styles.loadingImg} src={loadingSvg} alt="Loading" />
          </div>
        )}
        {/**標題 */}
        <div className={styles.title}>
          {`${t("Edit data for")} ${t(store.selectedTab)}`}
          <span className={styles.close} onClick={handleClose}>
            <CloseIcon />
          </span>
        </div>
        {/**表單 */}
        {/**cat3 special */}
        <div className={styles.main}>
          {specialCats.includes(EFSchema.cat) && (
            <div className={styles.inputWrap}>
              <label>Calculation Method</label>
              <Selector
                value={null}
                placeholder={flatEAFormData.calculationName}
                translation={"ActivityEF"}
                disabled={true}
                width={"730px"}
              />
            </div>
          )}

          {/**排放係數component */}
          {EFSchema?.cat === "4_3" ? (
            <>
              <EFFormComponent
                EFSchema={EFSchema.normal}
                formDataKey={"EFFormData"}
                handleSetFormData={store._handleSetEFFormData}
                target={"EFFormData"}
              />
              <EFFormComponent
                EFSchema={EFSchema.tran}
                formDataKey={"EFLandFormData"}
                handleSetFormData={store._handleSetEFFormData}
                target={"EFLandFormData"}
              />
            </>
          ) : (
            <SchemaSwitcher cat={EFSchema?.cat} defaultEFSchema={EFSchema} />
          )}

          {/**排放係數詳細資料component */}
          {isLoading ? null : <EFDec />}
        </div>
        {/**footer */}
        <div className={styles.footer}>
          <div className={styles.cancel} onClick={handleClose}>
            {t("Cancel")}
          </div>
          <div className={styles.add} onClick={handleEdit}>
            {t("Edit")}
          </div>
        </div>
      </div>
    </div>
  );
});
